import React, {useState} from 'react';

import Pagination from '../../../CoreWrappers/Pagination';

const NORMAL = 'normal';

const PaginationDrydock = () => {
	const renderPagination = () => {
		const props = {
			showLabel: '',
			dataLength: 100,
			onChange: ({current, size}) => console.log('Paginator onChange', {current, size})
		};

		return <Pagination {...props} />;
	};

	const renderSpacer = () => (
		<>
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
		</>
	);

	return (
		<>
			{renderSpacer()}
			{renderPagination()}
		</>
	);
};

export default PaginationDrydock;
